import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLocationDot} from "@fortawesome/free-solid-svg-icons";
import styles from "../../pages/Seances/SeancePage.module.css";
import React, {useEffect} from "react";

function BlocLocation({ lieu }) {
    let formatVille = `${lieu.ville}`;

    if (lieu.code_postal) {
        formatVille = `${lieu.ville}, ${lieu.code_postal}`;
    }

    return (
        <div className={styles.locationBloc}>
            <FontAwesomeIcon icon={faLocationDot}
                             style={{fontSize: '36px', color: "var(--clr-accent)", marginRight: "8px"}}/>

            <div className={styles.locationInfoBloc}>
                <span>À : {lieu.nom}</span>
                <span>Adresse : {lieu.adresse}</span>
                <span>Ville : {formatVille}</span>
            </div>
        </div>
    )
}

export default BlocLocation;